module.exports = __webpack_public_path__ + "img/e7832b2.jpg";